// www/src/components/ContactForm.js
import React, { useEffect, useState } from 'react';
import { API_BASE_URL } from '../config';
import { track } from '../lib/analytics';
import './ContactForm.css';

const EMAIL_RE = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;

export default function ContactForm({ services = [], initialPreferredService = '' }) {
  const [values, setValues] = useState({
    name: '', email: '', phone: '', preferredService: initialPreferredService, preferredTime: '', message: '', website: '',
  });
  const [status, setStatus] = useState({ state: 'idle', error: null });

  useEffect(() => {
    if (initialPreferredService) {
      setValues((v) => ({ ...v, preferredService: initialPreferredService }));
    }
  }, [initialPreferredService]);

  function set(field) {
    return (e) => setValues((v) => ({ ...v, [field]: e.target.value }));
  }

  async function onSubmit(e) {
    e.preventDefault();
    if (!values.name.trim() || !values.email.trim() || !values.message.trim()) {
      setStatus({ state: 'error', error: 'Name, email and message are required.' });
      return;
    }
    if (!EMAIL_RE.test(values.email)) {
      setStatus({ state: 'error', error: 'Please enter a valid email address.' });
      return;
    }
    setStatus({ state: 'sending', error: null });
    try {
      const res = await fetch(`${API_BASE_URL}/api/inquiries`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify(values),
      });
      if (!res.ok) throw new Error('submit-failed');
      setStatus({ state: 'success', error: null });
      track('INQUIRY_SUBMIT', '/contact');
      setValues({ name: '', email: '', phone: '', preferredService: '', preferredTime: '', message: '', website: '' });
    } catch (_) {
      setStatus({ state: 'error', error: 'Something went wrong. Please try again.' });
    }
  }

  if (status.state === 'success') {
    return <div className="contact-form-success">Thanks — I'll be in touch soon.</div>;
  }

  return (
    <form className="contact-form" onSubmit={onSubmit} noValidate>
      <label>
        Name *
        <input type="text" value={values.name} onChange={set('name')} maxLength={120} />
      </label>
      <label>
        Email *
        <input type="email" value={values.email} onChange={set('email')} maxLength={200} />
      </label>
      <label>
        Phone
        <input type="tel" value={values.phone} onChange={set('phone')} maxLength={30} />
      </label>
      <label>
        Preferred Service
        <select value={values.preferredService} onChange={set('preferredService')}>
          <option value="">— No preference —</option>
          {services.map((s) => <option key={s.id} value={s.name}>{s.name}</option>)}
          <option value="Other">Other / not sure</option>
        </select>
      </label>
      <label>
        Preferred Time
        <input type="text" value={values.preferredTime} onChange={set('preferredTime')} maxLength={120} placeholder="e.g. weekday mornings" />
      </label>
      <label>
        Message *
        <textarea value={values.message} onChange={set('message')} maxLength={4000} rows={5} />
      </label>
      {/* honeypot — hidden from humans, bots fill */}
      <div aria-hidden="true" style={{ position: 'absolute', left: '-9999px', top: 'auto', width: 1, height: 1, overflow: 'hidden' }}>
        <label>Website<input type="text" name="website" tabIndex={-1} autoComplete="off" value={values.website} onChange={set('website')} /></label>
      </div>
      {status.error && <div className="contact-form-error">{status.error}</div>}
      <button className="contact-form-submit" type="submit" disabled={status.state === 'sending'}>
        {status.state === 'sending' ? 'Sending…' : 'Send'}
      </button>
    </form>
  );
}
